import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';

import {Icon} from '../../Icon';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type SwitchProps = {
  method?: 'delivery' | 'pickup';
  onPress: (value: 'delivery' | 'pickup') => void;
  disabled?: boolean;
  testID?: string;
};

function Switch({method, onPress, disabled, testID}: SwitchProps) {
  const styles = useStyles({disabled});
  const [_method, setMethod] = React.useState(method);

  /**
   * If method initial prop updates
   */
  React.useEffect(() => {
    setMethod(method);
  }, [method]);

  return (
    <PressableWithOpacityFeedback
      disabled={disabled}
      testID={testID}
      onPress={() => {
        setMethod(value => {
          const newValue = value === 'pickup' ? 'delivery' : 'pickup';
          onPress(newValue);
          return newValue;
        });
      }}>
      <View style={styles.containerStyle}>
        <View
          style={[styles.iconContainerStyle, _method === 'pickup' && styles.iconContainerStyleOn]}>
          <Icon
            style={_method === 'pickup' ? styles.iconOn : styles.iconOff}
            name="bag-shopping"
            size={16}
          />
        </View>
        <View
          style={[
            styles.iconContainerStyle,
            _method === 'delivery' && styles.iconContainerStyleOn,
          ]}>
          <Icon
            style={_method === 'delivery' ? styles.iconOn : styles.iconOff}
            name="truck"
            size={16}
          />
        </View>
      </View>
    </PressableWithOpacityFeedback>
  );
}

const useStyles = makeStyles((theme, {disabled}) => {
  return {
    containerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      backgroundColor: disabled ? theme.colors.grey3 : theme.colors?.legacy?.uiControls?.primary,
      height: 32,
      width: 64,
      borderRadius: Number.MAX_SAFE_INTEGER,
    },
    iconContainerStyle: {
      height: 24,
      width: 24,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: Number.MAX_SAFE_INTEGER,
    },
    iconContainerStyleOn: {
      backgroundColor: theme.colors.white,
    },
    iconOn: {
      color: disabled ? theme.colors.grey3 : theme.colors?.legacy?.text?.heading?.primary,
    },
    iconOff: {
      color: theme.colors.white,
    },
  };
});

export default Switch;
